import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { detect } from "detect-browser";
import * as React from "react";
import { connect } from "react-redux";
import { isFeatureEnabled } from "src/utilities";

import { Dispatch, StoreState } from "../store";
import { CustomerType, Score } from "../types/index";
import CustomerTypeFilter from "./CustomerTypeFilter";
import { FilterGroup } from "./Filters/constants";
import {
  ElectricityFilter,
  GasFilter,
  GlassFiberFilter,
  HeatingFilter,
} from "./Filters/ProductTypeFilter";

function mapStateToProps({ dashboardFilter }: StoreState) {
  return {
    dashboardFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    changeDashboardFilter: (filter: any) =>
      dispatch.dashboardFilter.changeDashboardFilter(filter),
    resetDashboardFilter: () => dispatch.dashboardFilter.resetDashboardFilter(),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface State {
  accordionExpanded: boolean;
}

class DashboardFilter extends React.Component<
  Props & StyledComponentProps,
  State
> {
  public state = { accordionExpanded: true };

  public render() {
    const { classes } = this.props;
    const browser = detect();
    return (
      <Accordion
        expanded={this.state.accordionExpanded}
        onChange={this.handleAccordionChange}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Dashboardfilter</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} md={6} lg={4}>
              <FormControl component="fieldset" margin="dense" fullWidth={true}>
                <FormLabel component="legend">Score</FormLabel>
                <RadioGroup
                  name="score"
                  value={this.props.dashboardFilter.score}
                  onChange={this.handleChange}
                  row={true}
                >
                  <FormControlLabel
                    value={Score.CHURN}
                    control={<Radio />}
                    label="Churn Score"
                  />
                  <FormControlLabel
                    value={Score.CLV}
                    control={<Radio />}
                    label="CLV"
                  />
                </RadioGroup>
              </FormControl>
              <CustomerTypeFilter
                onChange={this.handleCustomerTypeChange}
                customerType={this.props.dashboardFilter.customerType}
              />
            </Grid>

            <Grid item={true} xs={12} md={6} lg={4}>
              <FormControl margin="dense" fullWidth={true}>
                <FormLabel component="div">Zeitverlauf</FormLabel>
                <TextField
                  id="standard-select-currency"
                  select={true}
                  label="Zeitraum"
                  value={this.props.dashboardFilter.dateRange}
                  onChange={this.handleChange}
                  margin="normal"
                  name="dateRange"
                  variant="outlined"
                  fullWidth={true}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        className={
                          browser && browser.name === "ie"
                            ? classes && classes.inputAdornmentIEFix
                            : undefined
                        }
                        position="start"
                      >
                        Monate
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={12}>12</MenuItem>
                  <MenuItem value={24}>24</MenuItem>
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item md={6} lg={4}>
                  <ElectricityFilter
                    electricityFilter={
                      this.props.dashboardFilter.electricityFilter
                    }
                    superordinateFilter="DashboardFilter"
                    enabled={
                      this.props.dashboardFilter.filterGroupsEnabled.electricity
                    }
                    changeFilter={this.props.changeDashboardFilter}
                    handleEnabledChange={this.toggleFilterGroupEnabled}
                  />
                </Grid>
                <Grid item md={6} lg={4}>
                  <GasFilter
                    gasFilter={this.props.dashboardFilter.gasFilter}
                    superordinateFilter="DashboardFilter"
                    enabled={this.props.dashboardFilter.filterGroupsEnabled.gas}
                    changeFilter={this.props.changeDashboardFilter}
                    handleEnabledChange={this.toggleFilterGroupEnabled}
                  />
                </Grid>
                <Grid item md={6} lg={4}>
                  <HeatingFilter
                    heatingFilter={this.props.dashboardFilter.heatingFilter}
                    superordinateFilter="DashboardFilter"
                    enabled={
                      this.props.dashboardFilter.filterGroupsEnabled.heating
                    }
                    changeFilter={this.props.changeDashboardFilter}
                    handleEnabledChange={this.toggleFilterGroupEnabled}
                  />
                </Grid>
                {isFeatureEnabled(process.env.REACT_APP_FEATURE_GLASS_FIBER) ? (
                  <Grid item md={6} lg={4}>
                    <GlassFiberFilter
                      glassFiberFilter={
                        this.props.dashboardFilter.glassFiberFilter
                      }
                      superordinateFilter="DashboardFilter"
                      enabled={
                        this.props.dashboardFilter.filterGroupsEnabled
                          .glassFiber
                      }
                      changeFilter={this.props.changeDashboardFilter}
                      handleEnabledChange={this.toggleFilterGroupEnabled}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            <Grid item={true} xs={12}>
              <Grid container={true} justify="flex-end">
                <Grid item={true}>
                  <Button onClick={this.handleResetPress} variant="contained">
                    Filter zurücksetzen
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }

  private handleResetPress = () => {
    this.props.resetDashboardFilter();
  };

  private handleAccordionChange = (
    event: React.ChangeEvent<{}>,
    expanded: boolean
  ): void => {
    this.setState({ accordionExpanded: expanded });
  };

  private handleDateChange = (date: Date) => {
    this.props.changeDashboardFilter({ date });
  };

  private toggleFilterGroupEnabled = (
    filterGroup: FilterGroup,
    enabled: boolean
  ) => {
    this.props.changeDashboardFilter({
      filterGroupsEnabled: {
        ...this.props.dashboardFilter.filterGroupsEnabled,
        [filterGroup]: enabled,
      },
    });
  };

  private handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    this.props.changeDashboardFilter({ [name]: value });
  };

  private handleCustomerTypeChange = (customerType: CustomerType[]) => {
    this.props.changeDashboardFilter({
      customerType,
    });
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  inputAdornmentIEFix: {
    marginRight: "17px",
  },
  paper: {
    overflowY: "hidden",
    padding: theme.spacing(2),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DashboardFilter));



// WEBPACK FOOTER //
// ./src/components/DashboardFilter.tsx